import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Button,
  Box,
  TextField,
  InputAdornment,
} from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneInput from 'react-phone-input-2';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import 'react-phone-input-2/lib/material.css';

const labelStyle = {
  marginBottom: '4px',
  fontWeight: 500,
  color: '#1A1A1A',
};

const inputStyle = {
  height: '46px',
  backgroundColor: '#fff',
  fontSize: '13px',
};

const CompanyDetails = ({ onCancel, onSave }) => {
  const [isEditable, setIsEditable] = useState(false);
  const [showButtons, setShowButtons] = useState(false); // Hidden by default

  const handleEditClick = () => {
    setIsEditable(true);
    setShowButtons(true); // Show buttons on edit
  };

  const handleCancel = () => {
    setShowButtons(false); // Hide buttons
    setIsEditable(false);  // Disable inputs
    if (onCancel) onCancel();
  };

  const handleSave = () => {
    setShowButtons(false); // Hide buttons
    setIsEditable(false);  // Disable inputs
    if (onSave) onSave();
  };

  return (
    <form>
      {/* Header Section */}
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          mt: 2,
        }}
      >
        <Typography sx={{ color: '#64748B', fontSize: '16px', fontWeight: '600' }}>
          Details
        </Typography>
        <Button
          onClick={handleEditClick}
          sx={{
            fontSize: '14px',
            borderRadius: '50px',
            color: '#0076FE',
            textTransform: 'capitalize',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          <EditOutlinedIcon sx={{ fontSize: '18px' }} />
          Edit Company Details
        </Button>
      </Box>

      {/* Grid Form */}
      <Grid container spacing={2} mt={1}>
        {/* Company Name - always disabled */}
        <Grid item size={{ xs: 12, md: 12 }}>
          <Typography variant="body2" sx={labelStyle}>
            Company Name
          </Typography>
          <TextField
            fullWidth
            value="Acadecraft Pvt. Ltd."
            variant="outlined"
            disabled
            InputProps={{ sx: {
    ...inputStyle,
    '&.Mui-disabled': {
      backgroundColor: 'var(--bs-secondary-bg)',
    },
  }, }}
          />
        </Grid>

        {/* Work Email */}
        <Grid item size={{ xs: 12, md: 6 , sm: 6}}>
          <Typography variant="body2" sx={labelStyle}>
            Work Email
          </Typography>
          <TextField
            fullWidth
            placeholder="Enter your work email"
            defaultValue="john.doe@email.com"
            variant="outlined"
            disabled={!isEditable}
            InputProps={{
              sx: {
    ...inputStyle,
    '&.Mui-disabled': {
      backgroundColor: 'var(--bs-secondary-bg)',
    },
  },
              startAdornment: (
                <InputAdornment position="start">
                  <MailOutlineIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        {/* Phone Number */}
        <Grid item size={{ xs: 12, md: 6  , sm: 6}}>
          <Typography variant="body2" sx={labelStyle}>
            Phone Number
          </Typography>
          <PhoneInput
            country={'in'}
            disabled={!isEditable}
            inputStyle={{
              width: '100%',
              height: '46px',
              fontSize: '13px',
              borderRadius: '4px',
            }}
            containerStyle={{ width: '100%' }}
            placeholder="Enter your phone number"
            enableSearch
          />
        </Grid>

        {/* Work Address - always disabled */}
        <Grid item size={{ xs: 12, md: 12 }}>
          <Typography variant="body2" sx={labelStyle}>
            Work Address
          </Typography>
          <TextField
            fullWidth
            placeholder="Enter your address"
            defaultValue="45 Oak Street, Apt 3C, New York, NY 10001, USA"
            variant="outlined"
            disabled
            InputProps={{ sx: {
    ...inputStyle,
    '&.Mui-disabled': {
      backgroundColor: 'var(--bs-secondary-bg)',
    },
  }, }}
          />
        </Grid>

        {/* Buttons Grid - shown only when editing */}
        {showButtons && (
          <Grid
            item
            size={{ xs: 12, md: 12 }}
            sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}
          >
            <Button
              variant="outlined"
              color="inherit"
              sx={{
                fontSize: '14px',
                borderRadius: '50px',
                background: '#fff',
                border: '1px solid #9095A1',
                color: '#9095A1',
              }}
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{
                fontSize: '14px',
                borderRadius: '50px',
                background: '#0076FE',
                border: '1px solid #0076FE',
                color: '#fff',
              }}
              onClick={handleSave}
            >
              Save & Update
            </Button>
          </Grid>
        )}
      </Grid>
    </form>
  );
};

export default CompanyDetails;
